import { gql } from '@apollo/client';

export const PATIENT_TIMEZONE = gql`
	query User($userId: UUID!) {
		user(id: $userId) {
			id
			profile {
				timezone
			}
		}
	}
`;
